module.exports = __webpack_public_path__ + "img/xwzx_img.7fc140d8.png";